import QuestionModel from "../../maths/QuestionModel";
import QuestionViewStatement from "./QuestionViewStatement";

export default class QuestionViewStatementMulti extends QuestionViewStatement {
    constructor(question) {
        super(question);
        this.signals.slotChosen = new P3.utils.MiniSignal();
    }

    createStatement(spacing = 40) {
        let width = 0;

        const operands = [];
        for (let i = 1; i < this._question.values.length; ++i) {
            let operand = "=";
            if (i < this._question.values.length - 1) {
                switch (this._question.type) {
                    case QuestionModel.TYPE_ADDITION : {
                        operand = "+";
                        break;
                    }
                    case QuestionModel.TYPE_SUBTRACTION : {
                        operand = "-";
                        break;
                    }
                    case QuestionModel.TYPE_MULTIPLICATION : {
                        operand = "x";
                        break;
                    }
                    case QuestionModel.TYPE_DIVISION : {
                        operand = "÷";
                        break;
                    }
                }
            }
            operands.push(operand);
        }

        const inputFieldsClone = this._inputField.slice();
        const partClone = this._question.part.slice();

        for (let i = 0, j = 0; i < this._question.values.length; ++i) {
            const value = this._question.values[i];
            const ndx = partClone.indexOf(i);

            if (ndx === -1) {
                const label = this.createLabel(value.toString(false));
                label.position.set(width, 0);
                this._footer.statement.addChild(label);

                if (i < this._question.values.length - 1) {
                    width += label.width + spacing;
                }
            } else {
                i > 0 && (width += inputFieldsClone[ndx].width * 0.5);

                inputFieldsClone[ndx].position.set(width, 0);
                this._footer.statement.addChild(inputFieldsClone[ndx]);

                i < this._question.values.length - 1 && (width += inputFieldsClone[ndx].width * 0.5 + spacing);

                inputFieldsClone.splice(ndx, 1);
                partClone.splice(ndx, 1);
            }

            // add operand
            const label = this.createLabel(operands[j++]);
            label.position.set(width, 0);
            this._footer.statement.addChild(label);

            i < this._question.values.length - 1 && (width += label.width + spacing);
        }

        // center statement
        this._footer.statement.pivot.x = width * 0.5;
    }

    setAnswer(value, ndx, inputNdx) {
        this._inputValue = value;
        this._inputField[ndx].label.text = value ? value.toString(false) : "?";
        if(value === '?')
            this._inputField[ndx].label.scale.set(1);
        else if(this._inputField[ndx].label.width > this._inputField[ndx].texture.width - 25){
            this._inputField[ndx].label.width = this._inputField[ndx].texture.width - 25;
            this._inputField[ndx].label.scale.y = this._inputField[ndx].label.scale.x;
        }
        this._inputField[ndx].inputNdx = inputNdx;
    }

    initInputField() {
        this._inputField = [];
        for (let i = 0; i < this._question.part.length; i++) {
            const inputField = new PIXI.Sprite(P3.assets.texture("ui_drop_in_area"));
            inputField.anchor.set(0.5);
            this.addChild(inputField);

            inputField.label = new PIXI.Text("?", {fontSize: 48, fontFamily: "BBC Reith Sans", fontWeight: "bold"});
            inputField.label.anchor.set(0.5);
            inputField.label.resolution = 2;
            inputField.addChild(inputField.label);

            inputField.interactive = true;
            inputField.buttonMode = true;

            inputField.click = inputField.touchstart = (e) => this.onInputFieldClick(e);

            this._inputField.push(inputField);
        }
    }

    onInputFieldClick(e) {
        const index = this._inputField.indexOf(e.target);
        this.signals.slotChosen.dispatch(index, e.target.inputNdx);
    }

    isCorrect() {
        let statement = "";
        const count = this._inputField.length;
        for (let i = 0; i < count; ++i) {
            statement += this._inputField[i].label.text;
            if (i < count - 1) {
                switch (this._question.type) {
                    case QuestionModel.TYPE_ADDITION : statement += " + "; break;
                    case QuestionModel.TYPE_SUBTRACTION : statement += " - "; break;
                    case QuestionModel.TYPE_MULTIPLICATION : statement += " * "; break;
                    case QuestionModel.TYPE_DIVISION : statement += " / "; break;
                }
            }
        }
        return eval(statement) === this._question.result.value;
    }
}